import { render, staticRenderFns } from "./OrdersFBMEditing.vue?vue&type=template&id=a30090d6&scoped=true"
import script from "./OrdersFBMEditing.vue?vue&type=script&lang=js"
export * from "./OrdersFBMEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30090d6",
  null
  
)

export default component.exports